/* @flow */

export const maxTopbarContentHeight = 56;
export const topBarMarginBottom = 16;
export const mobileBarHeight = 88;
